export default __webpack_public_path__ + "static/media/medicasur-logo-small.0bcdddaf.png";